<template>
  <PageHeader
    :title="entity.title"
    hero-class="bg-event py-6 lg:py-0"
    :breadcrumb="[ 'Médiatár',{ name:'Albumok', url:'/mediatar/albumok'}, entity.title ]"
  >
    <ReOverlayLoader :loading="loading">
      <div
        v-if="isAdmin() "
        class="float-right mt-[-40px] flex" 
      >
        <nuxt-link
          v-if="isAdmin()"
          :to="'/admin/zeneialbumok/album/' + entity.id"
          class="action-icon icon-yellow mr-4"
        >
          <i class="fas fa-cog pr-0" />
        </nuxt-link>
      </div>
      <div class="flex flex-col lg:flex-row gap-x-6"> 
        <div class="lg:w-96 order-2 lg:order-1 ">
          <div
            v-if="entity.thumbnail"
            class="hidden lg:block"
          >
            <RePictureSet
              v-if="entity.thumbnail"
              :image="entity.thumbnail"
              image-class="img-fluid lazyload px-[15px] mb-[25px] lg:px-0"
              sizes="180px"
            />
          </div>
          <div
            v-if="entity.links && entity.links.length > 0"
            class="bg-white pb-[20px]"
          >
            <div class="bg-yellow text-center w-full text-white py-[10px] text-2xl mt-[20px]">
              <h4>Kapcsolódó oldalak</h4>
            </div>
            <p
              v-for="(link, index) in entity.links"
              :key="index"
              class="px-[40px] mt-[20px]"
            >
              <a
                :href="
                  link.url.includes('http') ? link.url : 'http://' + link.url
                "
                target="_blank"
                class="link-red "
              >{{ link.name }}</a>
            </p>
          </div>
        </div>
        <div class="min-w-0 order-1 lg:order-2 w-full lg:static lg:max-h-full lg:overflow-visible bg-white ">
          <div
            v-if="entity.thumbnail"
            class="lg:hidden"
          >
            <RePictureSet
              v-if="entity.thumbnail"
              :image="entity.thumbnail"
              image-class="img-fluid lazyload px-[15px] mb-[25px] lg:px-0"
              sizes="180px"
            />
          </div>
          <div class="p-[25px]">
            <div
              v-if="entity.performers.length > 0"
              class="flex flex-col lg:flex-row mb-3"
            >
              <div class="w-full lg:w-1/3">
                <p class="font-semibold text-lg">
                  Előadó:
                </p>
              </div>
              <div class="w-full ">
                <p class=" text-lg">
                  <span
                    v-for="(item, index) in entity.performers"
                    :key="index"
                  >{{
                    item.name +
                      (index === entity.performers.length - 1 ? "" : ", ")
                  }}</span>
                </p>
              </div>
            </div>
            <div
              v-if="entity.editors && entity.editors.length > 0 && entity.editors[0]"
              class="flex flex-col lg:flex-row mb-3"
            >
              <div class="w-full lg:w-1/3">
                <p class="font-semibold  text-lg">
                  Szerkesztő:
                </p>
              </div>
              <div class="w-full">
                <p class=" text-lg">
                  <span
                    v-for="(item, index) in entity.editors"
                    :key="index"
                  >{{
                    item + (index !== entity.editors.length -1 ? ', ' : '')
                  }}</span>
                </p>
              </div>
            </div>
            <div
              v-if="entity.publishers.length > 0"
              class="flex flex-col lg:flex-row mb-3"
            >
              <div class="w-full lg:w-1/3">
                <p class="font-semibold  text-lg">
                  Kiadó:
                </p>
              </div>
              <div class="w-full">
                <p class=" text-lg">
                  <span
                    v-for="(item, index) in entity.publishers"
                    :key="index"
                  >{{ item.name }}</span>
                </p>
              </div>
            </div>
            <div
              v-if="entity.publication_year"
              class="flex flex-col lg:flex-row mb-3"
            >
              <div class="w-full lg:w-1/3">
                <p class="font-semibold text-lg">
                  Megjelenés éve:
                </p>
              </div>
              <div class="w-full">
                <p class=" text-lg">
                  {{ entity.publication_year }}
                </p>
              </div>
            </div>
            <div
              v-if="entity.production_number"
              class="flex flex-col lg:flex-row mb-3"
            >
              <div class="w-full lg:w-1/3">
                <p class="font-semibold text-lg">
                  Azonosító:
                </p>
              </div>
              <div class="w-full">
                <p class=" text-lg">
                  {{ entity.production_number }}
                </p>
              </div>
            </div>
          </div>
          <MainTitle
            v-if="entity.description"
            title="Leírás"
            class="w-full left-0 font-semibold font-source-serif-pro"
          />
          <p
            v-if="entity.description"
            class="p-[25px] text-lg"
            v-html="toHtml(entity.description)"
          />
          <div v-if="entity.images.length > 0">
            <MainTitle
              title="További képek"
              class="font-semibold font-source-serif-pro"
            />
            <rxtgallery :images="entity.images" />
          </div> 
         

          <MainTitle
            title="Felvételek"
            bg-class="bg-red font-semibold font-source-serif-pro"
          />
          <div class="p-[25px]">
            <ul>
              <li
                v-for="(item, index) in entity.recordings"
                :key="index"
                class="pb-3 pb-lg-1"
              >
                <nuxt-link
                  class="link link-red text-lg"
                  :to="'/mediatar/felvetelek/' + item.id + '/' + item.slug"
                >
                  {{ item.title }}
                </nuxt-link>
              </li>
            </ul>
          </div>
          <div class="w-full flex flex-wrap place-content-center my-[20px] lg:my-[40px]">
            <facebook
              :url="metaUrl()"
              title="Facebook megosztás"
              button-class="mx-[8px]"
            />
            <twitter
              :url="metaUrl()"
              title="Twitter megosztás"
              button-class="mx-[8px]"
            />
            <email
              :url="metaUrl()"
              :subject="entity.title + ' | Médiatár | Folkrádió'"
              :text="entity.title + '%0D' + metaDescription()"
              title="Email küldés"
              button-class="mx-[8px]"
            />
          </div>
        </div>
      </div>
    </ReOverlayLoader>
  </PageHeader>
</template>

<script>
import RePictureSet from '~/components/rxt/recomponent/RePictureSet.vue'
import PageHeader from "~/components/folkradio/PageHeader.vue";
import ReOverlayLoader from "~/components/rxt/recomponent/ReOverlayLoader.vue";
const MainTitle = () => import("~/components/folkradio/MainTitle.vue")
const rxtgallery = () => import("~/components/rxt/recomponent/ReGallery.vue");
const facebook = () => import("~/components/rxt/social/facebook.vue");
const twitter = () => import("~/components/rxt/social/twitter.vue");
const email = () => import("~/components/rxt/social/email.vue");
export default {
  components: {
    RePictureSet,
    rxtgallery,
    PageHeader,
    ReOverlayLoader,
    facebook,
    twitter,
    email,
    MainTitle
  },
  head() {
    return {
      titleTemplate: this.entity.title + " | Médiatár",
      meta: [
        {
          hid: "title",
          name: "title",
          content: this.entity.title + " | Médiatár"
        },

        {
          hid: "og:title",
          name: "og:title",
          property: "og:title",
          content: this.entity.title + " | Médiatár"
        },
        {
          hid: "og:image",
          name: "og:image",
          property: "og:image",
          content:
            this.entity.thumbnail
              ? this.entity.thumbnail.url
              : this.$getDomain() + "/img/meta_default.png"
        },
        {
          hid: "og:description",
          name: "og:description",
          property: "og:description",
          content: this.entity.performers.map(function(item, index) {
            return (index === 0 ? "" : " ") + item.name;
          })
        },
        {
          hid: "description",
          name: "description",
          content: this.entity.performers.map(function(item, index) {
            return (index === 0 ? "" : " ") + item.name;
          })
        },
        {
          hid: "og:url",
          name: "og:url",
          property: "og:url",
          content: this.metaUrl()
        },
        {
          hid: "og:site_name",
          name: "og:site_name",
          property: "og:site_name",
          content: "Folkrádió"
        }
      ]
    };
  },
  data() {
    return {
      entity: {},
      loading:false
    };
  },
  key: to => to.fullPath,
  scrollToTop: true,
  async asyncData(context) {
    try {
      const url = "/media/albums";
      let returnUrl = null;
      if (process.server) {
        returnUrl = "/mediatar/albumok";
      } else {
        returnUrl = context.app.router.history.current.fullPath;
      }

      const response = await context.app.$axios.get(
        url + "/" + context.params.id
      );

      const entity = response.data.data;

      return {
        id: entity.id,
        url,
        returnUrl,
        entity
      };
    } catch (error) {
      if (error.response && error.response.status === 404) {
        return context.error({
          statusCode: 404,
          message: "Album nem található!"
        });
      } else {
        return context.error({
          statusCode: 500,
          message: "Szerver hiba, kérlek lépj kapcsolatba az üzemeltetőkkel!"
        });
      }
    }
  },
  methods: {
    metaDescription() {
      return this.entity.performers
        .map(item => {
          return item.name;
        })
        .join(", ");
    },
    metaUrl() {
      return (
        this.$getDomain() +
        "/mediatar/albumok/" +
        this.entity.id +
        "/" +
        this.entity.slug
      );
    },
    toHtml(text) {
      return text ? text
        .trim()
        .replace(/\r\n/g, "<br>")
        .replace(/\n/g, "<br>") : "";
    }
  }
};
</script>
